import { Link } from "react-router-dom";

const categories = [
  {
    name: "免费追更",
    desc: "零门槛海量漫画",
    img: "https://readdy.ai/api/search-image?query=A%20bright%20flat%20illustration%20of%20free%20manga%20reading%20with%20gift%20boxes%20and%20coin%20icons%20on%20a%20smartphone%2C%20warm%20coral%20and%20green%20palette%2C%20cheerful%20free%20content%20theme%2C%20clean%20friendly%20style&width=600&height=400&seq=cat-free&orientation=landscape",
  },
  {
    name: "正版日漫",
    desc: "画质清晰同步更新",
    img: "https://readdy.ai/api/search-image?query=A%20clean%20illustration%20of%20anime%20manga%20books%20and%20copyright%20badge%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20palette%2C%20authentic%20licensed%20manga%20theme%2C%20gentle%20elegant%20style&width=600&height=400&seq=cat-jp&orientation=landscape",
  },
  {
    name: "国漫原创",
    desc: "独家连载社区互动",
    img: "https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20chinese%20manhua%20characters%20with%20ink%20brush%20and%20scroll%20motifs%2C%20warm%20coral%20orange%20and%20amber%20palette%2C%20original%20chinese%20comics%20theme%2C%20energetic%20bold%20style&width=600&height=400&seq=cat-cn&orientation=landscape",
  },
  {
    name: "韩漫专区",
    desc: "画风精致更新超快",
    img: "https://readdy.ai/api/search-image?query=A%20trendy%20illustration%20of%20stylish%20korean%20webtoon%20characters%20with%20city%20skyline%2C%20vibrant%20teal%20and%20pink%20palette%2C%20fashionable%20korean%20comic%20theme%2C%20modern%20trendy%20style&width=600&height=400&seq=cat-kr&orientation=landscape",
  },
  {
    name: "追更管理",
    desc: "跨平台不错过更新",
    img: "https://readdy.ai/api/search-image?query=A%20clean%20flat%20illustration%20of%20calendar%20reminder%20and%20bookmark%20with%20bell%20notification%20on%20a%20phone%2C%20warm%20amber%20and%20teal%20palette%2C%20tracking%20and%20reminder%20theme%2C%20organized%20tidy%20style&width=600&height=400&seq=cat-track&orientation=landscape",
  },
];

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">按需求快速筛选漫画软件应用</h2>
          <p className="mt-2 text-sm text-foreground-600">明确自己的追更需求，从对应分类里找好用的漫画软件应用</p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {categories.map((c) => (
            <Link
              key={c.name}
              to={`/rankings?cat=${encodeURIComponent(c.name)}`}
              className="group overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="aspect-[3/2] w-full overflow-hidden bg-background-200">
                <img
                  src={c.img}
                  alt={`${c.name}漫画软件应用`}
                  title={`${c.name}漫画软件应用`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-0.5 text-xs text-foreground-600">{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}